import { useState } from 'react';

import menuBurger from '../../../../assets/img/png/health-monitor/menu-burger.png';
import magnifier from '../../../../assets/img/svg/buttons/search.svg';
import update from '../../../../assets/img/svg/buttons/update.svg';
import { setSearchInput } from '../../../../store/slice/health-monitor/device-list';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import MobileFilters from '../../Header/Filters/MobileFilters';
import Button from '../../Common/Button';
import { t } from 'i18next';
import { useAllFilters } from '../../../../hook/useAllFilters';
import { useHeaderConfig } from '../../../../hook/useHeaderConfig';
import { useMenus } from '../../../../hook/useMenus';

interface Props {
  setShouldShowSearchBar: React.Dispatch<React.SetStateAction<boolean>>;
  setShouldShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
  setAnimateIn: React.Dispatch<React.SetStateAction<boolean>>;
  isMenuButtonActive: boolean;
  onMenuButtonClick: () => void;
  setIsMenuButtonActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileButtons: React.FC<Props> = ({
  setShouldShowSearchBar,
  isMenuButtonActive,
  onMenuButtonClick,
  setIsMenuButtonActive,
}) => {
  const [isSearchButtonActive, setIsSearchButtonActive] = useState(false);
  const dispatch = useAppDispatch();
  const { handleApplyAllFilters } = useAllFilters();

  const onSearchButtonClick = () => {
    setIsSearchButtonActive((prev) => !prev);
    if (isSearchButtonActive) {
      dispatch(setSearchInput(''));
    }
    setIsMenuButtonActive(false);
    setShouldShowSearchBar((prev) => !prev);
  };
  const menus = useMenus();
  const headerConfig = useHeaderConfig(menus);
  return (
    <div className="header_buttons">
      {headerConfig.updateData && (
        <Button icon={update} variant="filled" className="update_data" onClick={handleApplyAllFilters}>
          {t('statisticPage.header.buttons.updateData')}
        </Button>
      )}
      <button
        className={`search ${isSearchButtonActive ? 'active' : null}`}
        onClick={() => {
          onSearchButtonClick();
        }}
      >
        <img src={magnifier} alt="magnifier" />
      </button>

      {headerConfig.exportToExcel && headerConfig.exportToPDF && <MobileFilters></MobileFilters>}

      <button
        className={`menu ${isMenuButtonActive ? 'hidden' : null}`}
        onClick={() => {
          onMenuButtonClick();
        }}
      >
        <img src={menuBurger} alt="menu burger" />
      </button>
    </div>
  );
};

export default MobileButtons;
